import $ from 'jquery';
import $script from 'scriptjs';

import Forms from '../Forms';
import HeaderSearch from '../components/HeaderSearch';
import SearchForm from '../components/SearchForm';

export default class StaticSectionHeader {
  constructor(section) {
    this.$el = $(section.el);
    this.settings = section.data.settings;
    this.headerSearch = null;

    this.$scripts = $('[data-scripts]');

    this.$searchField = this.$el.find('[data-live-search]');

    this.forms = new Forms(this.$el);

    if (this.settings.live_search.enable) {
      $script(this.$scripts.data('shopify-api-url'), () => {
        this.headerSearch = new HeaderSearch({
          $el: this.$searchField,
          $header: this.$el,
        }, this.settings.live_search);
      });
    } else {
      this.headerSearch = new SearchForm(this.$searchField);
    }
  }

  onSectionUnload() {
    this.headerSearch.unload();
    this.forms.unload();
  }
}
